import React from "react";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";

const INVALID_CHARACTERS = ["’", "€"];

export function onDrop(file) {
    /** Sadly, we can't modify the file object (readonly): Cannot set property name of #<File> which has only a getter.
     * So we need to do the error handling and checks by ourselves, by checking file name.
     */
    // We can only upload 1 file at a time using DropzoneS3Uploader.
    let containsInvalidCharacter = false;

    if(file.length > 0 && file[0].name) {
        containsInvalidCharacter = INVALID_CHARACTERS.some((char) => file[0].name.includes(char));
    }

    if (containsInvalidCharacter) {
        const invalidCharsString = INVALID_CHARACTERS.toString();

        toast(<FormattedMessage id="fileNameSpecialCharError" values={{invalidChars: invalidCharsString}}/>, {
            type: toast.TYPE.ERROR,
            autoClose: false,
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/common/attachments/S3UploaderHelper.js